export default __webpack_public_path__ + "static/media/Netflix_Logo.4bc1d7fc.png";